<template>
  <div>
    <!-- <PropertyReadOnlyInf
      v-model="property"
      :property="property"
      :properties="properties"
      :required="false"
      @search="onPropertySearch"
    /> -->
    <PropertyRentalsPageTab v-if="property && properties.length > 0" :property="property" />
  </div>
</template>
<script>
// import PropertyReadOnlyInf from "@/components/PropertyReadOnlyInf.vue";
import PropertyRentalsPageTab from "@/components/PropertyRentals/PropertyRentalsPageTab.vue";
import { mapState } from "vuex";
import axios from "@/plugins/axios";
import { API_BASE_URL } from "@/config";
export default {
  name: "PropertyRentalsHistory",
  components: {
    // PropertyReadOnlyInf,
    PropertyRentalsPageTab,
  },
  data() {
    return {
      header: { Authorization: "Bearer " + this.$store.state.AccessToken },
      property: null,
      properties: [],
    };
  },
  computed: {
    ...mapState({
      rentalId: (state) => state.rentalId || null,
    }),
  },
  mounted() {
    this.initProperty();
  },
  beforeDestroy() {
    this.$store.commit("setPropertyDataForAppBar", null);
  },
  watch: {
    rentalId() {
      this.initProperty();
    },
    property: {
      handler(newVal) {
        if (
          newVal &&
          this.properties.length > 0 &&
          this.properties.some((p) => p.id === newVal.id)
        ) {
          this.$store.commit("setPropertyDataForAppBar", newVal);
        } else if (!newVal) {
          this.$store.commit("setPropertyDataForAppBar", null);
        }
      },
      deep: true,
    },
  },
  methods: {
    initProperty() {
      this.fetchProperties().then(() => {
        this.setProperty();
      });
    },
    setProperty() {
      if (!this.rentalId) {
        this.$router.push("/property-rentals");
        this.$store.commit("setPropertyDataForAppBar", null);
        return;
      }

      this.$store.commit("setLoading", true);
      axios
        .get(API_BASE_URL + "/property_rentals/" + this.rentalId, {
          headers: this.header,
        })
        .finally(() => this.$store.commit("setLoading", false))
        .then((response) => {
          const rental = response?.data?.data || null;
          const rentalProperty = rental?.property || null;

          if (
            rentalProperty &&
            this.properties.some((p) => p.id === rentalProperty.id)
          ) {
            this.property = rentalProperty;
            this.$store.commit("setPropertyDataForAppBar", rentalProperty);
          } else {
            this.property = null;
            this.$store.commit("setPropertyDataForAppBar", null);
          }
        })
        .catch(() => {
          this.property = null;
          this.$store.commit("setPropertyDataForAppBar", null);
        });
    },
    fetchProperties(search) {
      const url =
        API_BASE_URL +
        "/properties" +
        (search ? "?search=" + encodeURIComponent(search) : "");
      return axios
        .get(url, { headers: this.header })
        .then(({ data }) => {
          this.properties = data.data || [];
        })
        .catch(() => {})
        .finally(() => {});
    },
    onPropertySearch(search) {
      this.fetchProperties(search);
    },
  },
};
</script>
